import { apiAuthorToProps } from "~/lib/shared/apiAuthorToProps";
import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { Author } from "~/types/asgard/Author";
import { type AuthorBioProps } from ".";

export const apiToAuthorBioProps = (
  authors: Author[]
): AuthorBioProps[] | null => {
  if (!authors?.length) {
    return null;
  }
  return authors.map<AuthorBioProps>((author) => ({
    ...apiAuthorToProps(author),
    authorNicename: heDecodeOrDefault(author.author_nicename),
    href: heDecodeOrDefault(author.author_nicename)
      ? `/authors/${heDecodeOrDefault(author.author_nicename)}`
      : "",
  }));
};
